import React from 'react';
import './Experience.css'

const Experience = () => {
    return (
        <div data-aos="flip-left" data-aos-duration="1000">
            <ul>
                <li><span>2021 - Current</span><br />UI/UX</li>
                <li><span>2019 - 2021</span><br />College student</li>
                <li><span>2016 - 1017</span><br />School</li>
            </ul>
        </div>
    );
};

export default Experience;